export default __webpack_public_path__ + "static/media/NotoSans-SemiBold.8b4bbf0e.ttf";